// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type BookmarkFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from bookmark-filled.svg
 */
export default function BookmarkFilledIcon(props: BookmarkFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="BookmarkFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M13 0a1 1 0 0 1 .993.883L14 1v14a1 1 0 0 1-1.534.846l-.09-.065L8 12.28l-4.375 3.5a1 1 0 0 1-1.6-.556l-.02-.112L2 15V1a1 1 0 0 1 .883-.993L3 0z"
        />
      </g>
    </svg>
  );
}
